import React from "react"
import { ButtonConnect } from "@/components/buttonConnect"
import { Container, Stack, Typography } from "@mui/material"
import useTrans from "@/hooks/useTrans"
import Image from "next/image"
import DogWalletImage from "@/assets/images/dog-cute-wallet.png"

const NotConnectWallet = () => {
  const trans = useTrans()

  return (
    <Container maxWidth='xl'>
      <Stack
        alignItems='center'
        gap={2}
        className='bg-white border border-solid border-secondary rounded-lg p-3 sm:px-10 sm:py-6'
        data-testid='staking-not-connect-wallet'
      >
        <Typography className='font-semibold text-left text-xl sm:text-2xl w-full'>
          {trans.staking.detail.my_assets}
        </Typography>

        <Image src={DogWalletImage} alt='doge-question' width={115} />
        <Typography className='text-neutral-900 text-sm sm:text-base'>
          {trans.staking.detail.connect_wallet_to_view_reward}
        </Typography>
        <ButtonConnect showDropDownIcon={false} style={{ width: "100%" }} />
      </Stack>
    </Container>
  )
}

export default NotConnectWallet
